// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"631aca13","453":"023c98a7","455":"e3569ba7"}[chunkId] + ".chunk.js";
};